import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { getAppRootUrl } from '../../../../core/helpers';
import { PlatformLocation, NgClass } from '@angular/common';
import { OutSideClickDirective } from '../../../../directives/outside-click.directive';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, OutSideClickDirective],
})
export class DropdownComponent {
  @Input() isOpen = false;
  @Output() navigate = new EventEmitter<boolean>();

  private readonly locationService = inject(PlatformLocation);

  url?: string;

  constructor() {
    this.url = this.locationService.hostname
      ? getAppRootUrl[
          this.locationService.hostname as keyof typeof getAppRootUrl
        ] ?? undefined
      : undefined;
  }

  toggleDesktopMenu(isOpen: boolean) {
    this.isOpen = isOpen;
  }

  handleClick(): void {
    this.isOpen = false;
    this.navigate.emit(false);
  }
}
